import React, { Component } from 'react';
import BioPhoto from './BioPhoto';
import MemberQRCard from './MemberQRCard';
import watcharapols from '../assets/watcharapols.png';
import renshinkan from '../assets/renshinkan.png';
import logo from '../assets/logo.png';
import logo2 from '../assets/logo2.png';
import './CSS/Bio.css';

class BioWatcharapols extends Component {
  state = {
    user: null,
    loading: true,
    error: '',
  };

  async componentDidMount() {
    try {
      const email = localStorage.getItem('email');

      if (!email) {
        throw new Error('No email found. Please login again.');
      }

      const res = await fetch(`/user-details?email=${encodeURIComponent(email)}`);
      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Failed to fetch user data');
      }

      this.setState({
        user: {
          email: data.email,
          balance: data.balance,
          name: 'MR.WATCHARAPOL SUPAJAKWATTANA',
          dojo: 'RENSHINKAN DOJO, CHIANG MAI, THAILAND',
          rank: '2 DAN',
          rankDate: 'N/A',
          membershipNumber: '3245',
          membershipExpiry: 'N/A',
          nationality: 'THAILAND',
        },
        loading: false,
      });

    } catch (err) {
      console.error('Error fetching user data:', err);
      this.setState({
        error: err.message,
        loading: false,
      });
    }
  }

  renderUserInfo() {
    const { user } = this.state;

    return (
      <div style={{ marginBottom: '20px' }}>
        <div><strong>Email:</strong> {user.email}</div>
        <div><strong>Balance:</strong> {user.balance}</div>
      </div>
    );
  }

  renderRank() {
    const { user } = this.state;

    if (!user) return '2 DAN (N/A)';

    return user.rankDate
      ? `${user.rank} (${user.rankDate})`
      : user.rank;
  }

  render() {
    const { user, loading, error } = this.state;

    return (
      <div className="BioNiratb">
      <img
      className="top-logo"
      src={logo}
      alt="App Logo"
      />
        <h1>Member's Biography</h1>

        {loading && <div>Loading user data...</div>}

        {error && (
          <div style={{ color: 'red', marginBottom: '20px' }}>
            {error}
          </div>
        )}

        {user && this.renderUserInfo()}


        <BioPhoto
          slug="watcharapols"
          fallback={watcharapols}
          className="watcharapols"
          alt="Watcharapol Supajakwattana"
        />

        <h2>{user ? user.name : 'MR.WATCHARAPOL SUPAJAKWATTANA'}</h2>

        <img
          className="renshinkan"
          src={renshinkan}
          alt="Renshinkan Dojo"
        />

        <br />
        <br />

        <div>
          DOJO : {user ? user.dojo : 'RENSHINKAN DOJO, CHIANG MAI, THAILAND'}
        </div>

        <div>
          CURRENT RANK : {this.renderRank()}
        </div>

        <div>
          AAT MEMBERSHIP NUMBER : {user ? `${user.membershipNumber} (Expired : ${user.membershipExpiry})` : '3245 (Expired : N/A)'}
        </div>

        <div>
          DATE OF BIRTH : N/A
        </div>

        <div>
          NATIONALITY : {user ? user.nationality : 'THAILAND'}
        </div>

        <br />

        <MemberQRCard slug="watcharapols" />

        <br />

        <div>Powered by</div>

        <img
          className="logo2"
          src={logo2}
          alt="New Wave Consulting Group logo"
        />

        <div>New Wave Consulting Group</div>
      </div>
    );
  }
}

export default BioWatcharapols;
